import { environment as environmentDev } from "./environment";
import { environment as environmentProd } from "./environment.prod";

const env =
  process.env.REACT_APP_NODE_ENV === "production"
    ? environmentProd
    : environmentDev;

export const environment = env;
